import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    // Job detail is shareable — only applying requires auth (enforced in the component)
    if (/^\/jobs\/[^/]+/.test(state.url)) return true;
    // Preserve the originally-requested URL (e.g. a WhatsApp reminder's /meeting/:id deep
    // link) so login sends the user back here instead of the generic dashboard.
    router.navigate(['/auth/login'], { queryParams: { reason: 'unauthorized', returnUrl: state.url } });
    return false;
  }

  return true;
};
